import React from 'react';
import { Space, Text } from '@cashfree-intl/coherent';

import checkoutOneBannerIllustration from 'images/checkout-one-banner-illustration.svg';

import {
  StyledPitchPageContainer,
  StyledPitchPageHeading,
  StyledSecondaryButton,
  StyledBannerText,
  StyledBannerIllustrationImg,
  StyledActionWrapper,
} from '../styled';
import { CANVAS_DOCS_URL } from '../constants';

const CheckoutOneCanvasBanner = () => {
  const goToViewDocsPage = () => {
    window.open(CANVAS_DOCS_URL, '_blank');
  };

  return (
    <div>
      <StyledPitchPageContainer className="p-4">
        <Space alignItems="center" gap={3} justifyContent="space-between">
          <div>
            <Text color="selected" className="w-600">
              Introducing
            </Text>
            <StyledPitchPageHeading
              color="white"
              variant="h28"
              className="w-700"
            >
              Checkout Customisations
            </StyledPitchPageHeading>
            <StyledBannerText variant="b14" color="white">
              Checkout Customisations helps you customise every detail of your
              checkout, so you can truly make it an extension of your website.
            </StyledBannerText>
            <StyledActionWrapper className="mt-4">
              <StyledSecondaryButton
                onClick={goToViewDocsPage}
                data-event-name="checkout_one_learn_more"
                data-ignore-inner-text="true"
                className="mr-2"
                secondary
              >
                <span className="w-600">View Docs</span>
              </StyledSecondaryButton>
            </StyledActionWrapper>
          </div>
          <div>
            <StyledBannerIllustrationImg
              src={checkoutOneBannerIllustration}
              alt="Checkout One"
            />
          </div>
        </Space>
      </StyledPitchPageContainer>
    </div>
  );
};

export default CheckoutOneCanvasBanner;
